import { render } from "./bulkEditor.vue?vue&type=template&id=75192816&scoped=true"
import script from "./bulkEditor.vue?vue&type=script&lang=js"
export * from "./bulkEditor.vue?vue&type=script&lang=js"

import "./bulkEditor.vue?vue&type=style&index=0&id=75192816&scoped=true&lang=css"

import exportComponent from "/home/adachi/omega-base/omega/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75192816"]])

export default __exports__